import { useState } from 'react';

const FAQCouple = () => {
    const faqs = [
        {
          question: "What are the most romantic destinations for a couple's getaway?",
          answer: "Ah, the age-old question! It really depends on your vibe as a couple. For dreamy beach escapes, the Maldives, Santorini, and the Seychelles are always a hit. If you're more into exploring cities hand-in-hand, Paris, Venice, and Kyoto are overflowing with romance. And for adventurous couples, think Iceland, Patagonia, or even a safari in Africa!"
        },
        {
          question: "We're not honeymooners, but we want a romantic getaway. Any ideas?",
          answer: "Absolutely! Couple holidays are perfect for any stage of your relationship, whether you're celebrating an anniversary, rekindling the spark, or just needing some quality time together. Think cozy cabin getaways in the mountains, wine-tasting tours in Tuscany, or even a relaxing spa weekend in Bali. The possibilities are endless!"
        },
        {
          question: "What are some unique experiences we can do together on a couple's holiday?",
          answer: "Oh, there are so many! How about a private cooking class in Thailand, learning to make delicious local dishes? Or maybe a hot air balloon ride over Cappadocia at sunrise? You could even try a couples' massage workshop in Bali and learn to pamper each other. The key is to find activities that you'll both enjoy and that will create lasting memories."
        },
        {
          question: "We're on a tight budget. Can we still have an amazing couple holiday?",
          answer: "Definitely! Romantic getaways don't have to break the bank. Consider exploring charming towns off the beaten path, opting for cozy guesthouses instead of luxury resorts, and enjoying picnics and free activities like hiking and exploring local markets. With a little creativity, you can create a magical experience without overspending."
        },
        {
          question: "How can we make sure our couple holiday is truly unforgettable?",
          answer: "The most important ingredient is quality time together! Unplug from your devices, focus on each other, and try new things together. Choose a destination that speaks to both of your interests, and don't be afraid to splurge on a special experience or two that you'll cherish forever. And hey, don't forget to capture those memories with lots of photos!"
        }
      ];
      

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="mt-8 px-4 md:px-0">
      <h2 className="text-2xl font-semibold mb-4">FAQs</h2>
      {faqs.map((faq, index) => (
        <div key={index} className="mb-4 lg:w-[900px]">
          <div
            className={`cursor-pointer py-4 px-4 bg-white rounded-lg shadow-sm border border-light hover:shadow-md transition-shadow ${activeIndex === index ? 'pb-8' : ''}`}
            onClick={() => toggleAccordion(index)}
          >
            <div className="flex justify-between items-center">
              <h3 className="text-base md:text-lg font-medium w-[90%]">{faq.question}</h3>
              <svg
                className={`w-8 h-8 transition-transform duration-300 p-1 rounded-full text-halo-pink hover:bg-halo-pink hover:text-white focus:outline-none ${activeIndex === index ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
            {activeIndex === index && (
              <p className="mt-3 text-gray-700">{faq.answer}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQCouple;
